import { forwardRef } from "react";
import { adminActionButtonClass } from "./adminStyles";

const AdminPageHeader = forwardRef(({
  title,
  description,
  actionLabel,
  onAction,
  onActionKeyDown,
}, ref) => (
  <div className="mb-5 flex flex-wrap items-center justify-between gap-3">
    <div>
      <h1 className="text-xl font-semibold text-gray-800">{title}</h1>
      <p className="mt-0.5 text-xs text-gray-400">{description}</p>
    </div>
    {actionLabel ? (
      <button
        ref={ref}
        onClick={onAction}
        onKeyDown={onActionKeyDown}
        className={adminActionButtonClass}
      >
        {actionLabel}
      </button>
    ) : null}
  </div>
));

AdminPageHeader.displayName = "AdminPageHeader";

export default AdminPageHeader;